$(document).ready(function(){
	var imageSlider;
	const $sliderdiv = $('.image-slider');

	if ($sliderdiv && typeof $sliderdiv.slick == 'function') {

		imageSlider = $sliderdiv.slick({
			dots: true,
			infinite: true,
			speed: 300,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: false,
			autoplaySpeed: 7000,
			centerMode: false,
			variableWidth: false,
			prevArrow: '<button type="button" class="slick-prev">prev</button>',
			nextArrow: '<button type="button" class="slick-next">next</button>'
		});

		$sliderdiv.find('.slick-list').show();

		$sliderdiv.on("swipe", function(event, slick, direction) {
			imageSlider.slick('slickSetOption', {
				'autoplay': false
			}, true);
		});

		$(".slick-prev, .slick-next, .slick-dots button").on("click", function() {
			imageSlider.slick('slickSetOption', {
				'autoplay': false
			}, true);
		});

		imageSlider.on('init', function (event, slick) {
		});
	}

});